import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Firebase'in oturum durumunu kontrol etmesini bekliyoruz
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) return <div style={{padding: '50px', textAlign: 'center'}}>Yetki kontrol ediliyor...</div>;

    if (!user) {
        // Oturum yoksa Login'e gönder
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;